import { CountryPrefix } from 'Jsx/global';

import { InputMode } from '../../InputField';

export const getInputMode = (countryPrefix: CountryPrefix): InputMode => {
  switch (countryPrefix) {
    case 'mx':
      return 'text';
    default:
      return 'numeric';
  }
};
